<template>
  <div>
    <b-table-simple>
      <b-thead>
        <b-tr>
          <b-th>Course dev site</b-th>
          <b-th>Due date</b-th>
          <b-th>Academic/Program director</b-th>
          <b-th>OFDIT lead</b-th>
        </b-tr>
      </b-thead>

      <b-tbody>
        <b-td>
          <b-link target="blank" :href="reviewInfo.dev_site_url">
            {{ reviewInfo.course }}
            <b-icon icon="link45deg"></b-icon>
          </b-link>
        </b-td>
        <b-td>{{ reviewInfo.due_date }}</b-td>
        <b-td
          >{{ reviewInfo.academic_director_full_name }}
          <b-link :href="`mailto:${reviewInfo.academic_director_email}`">
            <b-icon icon="envelope"></b-icon>
          </b-link>
        </b-td>
        <b-td
          >{{ reviewInfo.ofdit_lead_full_name }}
          <b-link :href="`mailto:${reviewInfo.ofdit_lead_email}`">
            <b-icon icon="envelope"></b-icon>
          </b-link>
        </b-td>
      </b-tbody>
    </b-table-simple>
    <hr />
    <b-alert show variant="primary">
      <span v-html="instructions"></span
    ></b-alert>
  </div>
</template>
<script>
  import getInstructions from '@/assets/courseReview/instructions.js'

  export default {
    name: 'ReviewHeader',
    data() {
      return {}
    },
    computed: {
      reviewInfo() {
        return this.$store.getters.reviewInfo
      },
      instructions() {
        return getInstructions(this.reviewInfo)
      }
    }
  }
</script>
<style></style>
